// extracted by mini-css-extract-plugin
module.exports = {"progressSlider":"TimelinePrograssBar_progressSlider__2lwCI","durationMillis":"TimelinePrograssBar_durationMillis__Y8KhE"};